import {FC, ReactNode, useState} from 'react';
import {Control, Controller, FieldValues, RegisterOptions} from 'react-hook-form';
import {FormControl, FormHelperText, SxProps} from '@mui/material';
import {Theme} from '@mui/system';

import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import {PhoneMask} from './PhoneMask';

interface IPhoneInput {
  control: Control<any, any>;
  rules?:
    | Omit<RegisterOptions<FieldValues, string>, 'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'>
    | undefined;
  name: string;
  label?: string;
  size?: 'medium' | 'small';
  additionalFunc?: () => void;
  sx?: SxProps<Theme> | undefined;
  disabled?: boolean;
  endAdornment?: ReactNode;
}

const PhoneInput: FC<IPhoneInput> = (props) => {
  const {size, name, disabled, label, control, rules, endAdornment, sx} = props;

  const [isDirty, setIsDirty] = useState(false);

  return (
    <Controller
      control={control}
      rules={rules}
      name={name}
      render={({field: {value, onChange, ref}, fieldState: {error}}) => (
        <FormControl sx={sx}>
          <InputLabel
            sx={
              isDirty || value
                ? {
                    '&.Mui-focused': {
                      transform: 'translate(14px, -9px) scale(0.75)',
                      color: error ? '#d32f2f' : '',
                    },
                  }
                : {
                    '&:not(.Mui-focused)': {
                      transform: 'translate(14px, 9px) scale(1) !important',
                      color: error ? '#d32f2f' : '',
                    },
                  }
            }
            htmlFor={name}
          >
            {label}
          </InputLabel>
          <OutlinedInput
            onFocus={() => setIsDirty(true)}
            onBlur={() => setIsDirty(false)}
            id={name}
            onChange={(e) => {
              onChange(e);
            }}
            name={name}
            label={label}
            inputRef={ref}
            size={size}
            value={value}
            disabled={disabled}
            inputComponent={PhoneMask}
            error={!!error}
            autoComplete="off"
            endAdornment={endAdornment}
            inputProps={{
              'data-testid': 'phoneNumber',
            }}
          />
          <FormHelperText id={name} sx={error ? {color: '#d32f2f'} : {}}>
            {error ? error.message : ''}
          </FormHelperText>
        </FormControl>
      )}
    />
  );
};

export default PhoneInput;
